import styled, {css} from 'styled-components';
import PropTypes from 'prop-types';
import {color} from "./helpers/variables";

export const Paragraph = styled.p`
  font-size: 14px;
  font-weight: normal;
	line-height: 1.57;
  text-align: left;
  margin: ${props => props.mobileMargin ? '.5em 0 2em' : '1.5em 0'};
  color: ${color.black};
  
  ${props => props.uppercase && css`
    text-transform: uppercase;
  `}
  
  ${props => props.noMargin && css`
    margin: 0;
  `}
`;

Paragraph.propTypes = {
  uppercase: PropTypes.bool
};



// WEBPACK FOOTER //
// ./src/styles/Paragraph.js